module.exports = __webpack_public_path__ + "static/media/cloudSuite_footer.737305df.svg";